module.exports = __webpack_public_path__ + "assets/rating.96c361cc.svg";